import { IKeyValue } from 'shared/utils';
import { string } from 'yup';

export interface IListagemGrupoTeste {
  IdGrupoTeste: number,
  CodigoOrganizacao: number,
  NomeGrupoTeste: string,
  IdUsuarioInclusao: number,
  DataInclusao: string,
  IdComCanal: number,
  TipoGrupoTeste: string,
  ROW_NUM?: number,
  UsuNome: string;
  UsuId: number;
  Acao: string;
  DhUsuario: Date;
  Dhini: string;
  Dhfim: string;

}
export interface IListagemLogsGrupo {
  NomeGrupoTeste: string,
  IdGrupoTeste: number,
  UsuarioLog: string;
  UsuId: number;
  Acao: string;
  DataInclusao: Date;
  Dhini: string;
  Dhfim: string;
  TipoGrupoTeste: string;
  IdComCanal: number;

}

export interface IResponseGrupoTesteLog {
  rows: IListagemLogsGrupo[];
  count: number;
}
export interface IListagemLogsGrupotesteDestinatario {
  idDest: number;
  idTest: number;
  Nome: string;
  Descricao: string;
  dhUserIns: Date;
  dhUserFin: Date;
  Operacao: string;
  UserName: string;
  ROW_NUM?: number;


}

export interface IResponseGrupoTesteDestinatarioLog {
  rows: IListagemLogsGrupotesteDestinatario[];
  count: number;
}




export interface ICreateGrupoTeste {
  NomeGrupoTeste?: string,
  IdComCanal?: number,
  TipoGrupoTeste?: string,
}

export interface IResponseGrupoTeste {
  rows: IListagemGrupoTeste[];
  count: number;
}

export const InicitalCreateGrupoTeste = {
  NomeGrupoTeste: '',
  IdComCanal: 0,
  TipoGrupoTeste: '',
};


export const listKeyValueTipoGrupoTeste: IKeyValue[] = [
  {
    key: 'TEC',
    value: 'Técnico'
  }, {
    key: 'USU',
    value: 'Usuário'
  }];

export interface IListagemGrupoTesteDestinatario {
  IdGrupoTeste: number,
  NomeGrupoTeste: string,
  CodigoOrganizacao: number,
  CodigoNomeOrganizacao: string,
  IdGrupoTesteDestinatario: number,
  NomeDestinatario: string,
  DescricaoDestinatario: string,
  IdUsuarioInclusao: number,
  DataInclusao: string,
  ROW_NUM?: number
}

export interface ICreateGrupoTesteDestinatario {
  NomeDestinatario?: string,
  DescricaoDestinatario?: string,
}

export interface IResponseGrupoTesteDestinatario {
  rows: IListagemGrupoTesteDestinatario[];
  count: number;
}

export const InicitalCreateGrupoTesteDestinatario = {
  NomeDestinatario: '',
  DescricaoDestinatario: '',
};
